import IconWarn from "../images/icon-warn.svg?react"
import IconOffline from "../images/icon-offline.svg?react"

const VARIANTS = {
  UNRECOGNIZED: {
    Icon: IconWarn,
    iconClass: "icon-warn",
    title: "Not recognized",
    desc: "Make sure the math problem is clearly visible and try again.",
    primary: "Try again",
    ghost: "New question",
  },
  OFFLINE: {
    Icon: IconOffline,
    iconClass: "icon-offline",
    title: "No connection",
    desc: "Check your network connection and try again.",
    primary: "Try again",
    ghost: "New question",
  },
  SERVER: {
    Icon: IconWarn,
    iconClass: "icon-warn",
    title: "Something went wrong",
    desc: "The solver ran into a problem. Try again or rephrase your question.",
    primary: "Try again",
    ghost: "New question",
  },
}

export default function ErrorView({ kind, onRetry, onNewQuestion }) {
  const variant = VARIANTS[kind] || VARIANTS.UNRECOGNIZED
  const Icon = variant.Icon

  return (
    <div className="error-view">
      <div className={`err-icon ${variant.iconClass}`}>
        <Icon width={48} height={48} />
      </div>
      <div className="err-title">{variant.title}</div>
      <div className="err-desc">{variant.desc}</div>
      <div className="err-actions">
        <button type="button" className="solve-btn-main" onClick={onRetry}>
          {variant.primary}
        </button>
        <button type="button" className="err-ghost-btn" onClick={onNewQuestion}>
          {variant.ghost}
        </button>
      </div>
    </div>
  )
}
